import jquery from "jquery";

// 다음처럼 require()를 사용하면 sync하게 workman.json을 읽을 수 있지만,
// 배포 파일을 만들 때 uglifed 된 js 파일 내에 포함되어 버리기 때문에
// 그 아래 jquery.ajax()의 options에 async를 false로 해서 호출해야함
//
// require 대신에 import를 해도 될 것 같지만 동일하게 uglifed에서 문제가 발생할 듯..
// var json = require('../workman.json');
// const WORKMAN_URL = json.workman;
// const SECRET_KEY = json.secret;

var WORKMAN_URL = "http://127.0.0.1";
var SECRET_KEY = "";
var IV_KEY = "";

var json;
let options = {
  url: "/workman.json",
  method: "GET",
  async: false,
  success: data => {
    WORKMAN_URL = data.workman;
    SECRET_KEY = data.secret;
  },
};

jquery.ajax(options);

console.log("WORKMAN_URL = " + WORKMAN_URL);
// console.log('SECRET_KEY = ' + SECRET_KEY);

export { WORKMAN_URL, SECRET_KEY };
